import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { SerialConfirmOpenSlotsScreen } from '../confirm-open-slots-shared/serial-confirm-open-slots-screen.component';
import useDropOffConfirmOpenSlotsSerial from './drop-off-confirm-open-slots-serial.controller';

const ID = 'drop-off-confirm-open-slots-serial';

const DropOffConfirmOpenSlotsSerial = () => {
    const viewProps = useDropOffConfirmOpenSlotsSerial();

    return (
        <SerialConfirmOpenSlotsScreen
            id={ID}
            headerTitle={CommonMessage.BUTTONS.DROP_OFF}
            viewProps={viewProps}
            openSlotLabel={
                <FormattedMessage
                    id='kiosk.wizard.drop-off-confirm-open-slots-serial.open-slot'
                    defaultMessage='Open SLOT'
                    description='Button to open the current drop-off SLOT in the serial colli loop'
                />
            }
        />
    );
};

export default DropOffConfirmOpenSlotsSerial;
